import { authFetch } from './client';

// Projects shared INTO the caller's orgs (owner row loaded server-side).
export const listSharedProjects = () => authFetch('/api/projects/shared');
export const listCollaborators = (projectId) =>
  authFetch(`/api/projects/${projectId}/collaborators`);
export const shareProject = (projectId, userId, role) =>
  authFetch(`/api/projects/${projectId}/share`, {
    method: 'POST',
    body: JSON.stringify({ userId, role }),
  });
export const removeCollaborator = (projectId, userId) =>
  authFetch(`/api/projects/${projectId}/collaborators/${userId}`, { method: 'DELETE' });
// Self-service: drop the caller's OWN grant on a project shared into their org
// (the shared card knows the owner's userId). Removes it from "Shared Projects".
export const leaveSharedProject = (projectId, owner) =>
  authFetch(`/api/projects/${projectId}/shared?owner=${encodeURIComponent(owner)}`, {
    method: 'DELETE',
  });
// File sharing mirrors project sharing.
export const shareFile = (fileId, userId, role) =>
  authFetch(`/api/repository/${fileId}/share`, {
    method: 'POST',
    body: JSON.stringify({ userId, role }),
  });
